import { getAllLatestImages, getDeviceLatestImage } from 'src/services/cam-cloud/recordings';
import { devices } from 'src/stores/lists/devices';
import { camera_previews } from 'src/stores/features/cameras/previews';
import { get } from 'svelte/store';
import type { CloudLatestImage, CloudLatestImagesResponse } from '../types/cloud-recordings';

/**
 * Load Previews for all camera devices and store them in the camera_previews store
 * Guards against no camera devices in the account
 */
export const loadCameraDevicePreviews = async () => {
	let _devices = get(devices);
	if (!_devices) {
		return;
	}

	if (Object.values(_devices).filter((d: any) => d.category === 'camera').length === 0) {
		return;
	}

	const response = (await getAllLatestImages().catch((err) => {
		console.error('[Camera Cloud] Error fetching camera device previews', err);
		return {};
	})) as CloudLatestImagesResponse;
	let previews = response?.data || {};

	camera_previews.set(previews || {});

	return previews;
};

export const loadCameraDevicePreview = async (deviceId: string) => {
	if (!deviceId) {
		return;
	}
	const response = (await getDeviceLatestImage(deviceId).catch((err) => {
		console.warn(`Error fetching camera device (${deviceId}) preview`, err);
		return {};
	})) as CloudLatestImage;

	// Safeguard against no image
	if (!response?.large) {
		return {};
	}

	camera_previews.updateDevicePreview(deviceId, response);

	return response;
};
